(function() {
    // 注册组件
    SR.modules.extend('answer.packageData', packageData);

    function packageData(option) {
        // 为模板引擎包装数据
        var userInfo = SR.data.userInfo;
        var templateData = {
            id: option.id,
            avatar: userInfo.userAvatar,
            scene: option.scene,
            type: option.type,
            askOptions: option.askOptions
        };
        var templateHTML;

        try {
            if (option.type === 'stock') {
                // 股票场景
                switch (option.scene) {
                    case 'joke':
                        templateData = Object.assign(templateData, option);
                        templateHTML = template('joke', templateData);
                        break;
                    case 0: // 段子
                        templateData = Object.assign(templateData, option.data.data);
                        templateHTML = template('joke', templateData);
                        break;
                    case 1: // 行情
                        templateData = Object.assign(templateData, option.data.data);
                        templateHTML = template('quotation', templateData);
                        break;
                    case 2: // 诊断
                        templateData = Object.assign(templateData, option.data.data);
                        templateHTML = template('diagnose', templateData);
                        break;
                    case 3: // 新闻
                    case 4: // 公告
                    case 5: // 研报
                    case 55: // 板块资讯
                    case 70: // 分类资讯
                        templateData = Object.assign(templateData, option.data.data);
                        templateHTML = template('news_common', templateData);
                        break;
                    case 10: // 板块
                    case 41: // 个股概念
                        templateData = Object.assign(templateData, option.data.data, {
                            title: ['板块名称', '涨跌幅', '领涨个股']
                        });
                        templateHTML = template('block_common', templateData);
                        break;
                    case 13: // 涨幅
                    case 14: // 跌幅
                    case 15: // MACD黄金交叉
                    case 21: // 条件选股
                    case 24: // 短线股票
                    case 25: // 抄底股票
                    case 28: // 股票推荐
                    case 38: // 地区股票
                    case 82: // 科创板
                        templateData = Object.assign(templateData, option.data.data, {
                            title: ['股票名称', '股票价格', '涨跌幅'],
                            specialKeyName: ['changeAmountRateV']
                        });
                        templateHTML = template('stock_list_common', templateData);
                        break;
                    case 16: // 换手率
                    case 20: // 大单卖出
                        templateData = Object.assign(templateData, option.data.data, {
                            title: ['股票名称', '股票价格', '换手率'],
                            specialKeyName: ['turnoverRateV']
                        });
                        templateHTML = template('stock_list_common', templateData);
                        break;
                    case 17: // 资金流入大
                    case 18: // 资金流出大
                        templateData = Object.assign(templateData, option.data.data, {
                            title: ['股票名称', '股票价格', '资金流向'],
                            specialKeyName: ['capitalFlows']
                        });
                        templateHTML = template('stock_list_common', templateData);
                        break;
                    case 19: // 大单买入
                        templateData = Object.assign(templateData, option.data.data, {
                            title: ['股票名称', '股票价格', '当日DDX'],
                            specialKeyName: ['ddx'],
                            skNameHelperToggle: ['off'],
                        });
                        templateHTML = template('stock_list_common', templateData);
                        break;
                    case 22: // 区域板块
                        templateData = Object.assign(templateData, option.data.data, {
                            title: ['区域名称', '涨跌幅', '领涨个股(涨跌幅)']
                        });
                        templateHTML = template('block_common', templateData);
                        break;
                    case 23: // 行业板块
                        templateData = Object.assign(templateData, option.data.data, {
                            title: ['行业名称', '涨跌幅', '领涨个股(涨跌幅)']
                        });
                        templateHTML = template('block_common', templateData);
                        break;
                    case 26: // 机构关注股票
                        templateData = Object.assign(templateData, option.data.data);
                        templateHTML = template('org_concerned', templateData);
                        break;
                    case 27: // 概念板块
                        templateData = Object.assign(templateData, option.data.data, {
                            title: ['概念名称', '涨跌幅', '领涨个股(涨跌幅)']
                        });
                        templateHTML = template('block_common', templateData);
                        break;
                    case 29: // 新股
                        templateData = Object.assign(templateData, option.data.data);
                        templateHTML = template('ipo_stock', templateData);
                        break;
                    case 30: // 智能组合
                        if (SR.haveBeenToRiskTest && option.data.data.userStatus === 1) {
                            // 第二次打开时改变状态，提示用户
                            option.data.data.userStatus = 1.5;
                        }
                        templateData = Object.assign(templateData, option.data.data);
                        templateHTML = template('stock_combination', templateData);
                        break;
                    case 31: // 自选日报
                        templateHTML = template('daily', templateData);
                        break;
                    case 32: // 个股资金
                        templateData = Object.assign(templateData, option.data.data);
                        templateHTML = template('stock_funds', templateData);
                        break;
                    case 33: // 股价预测
                        templateData = Object.assign(templateData, option.data.data);
                        templateHTML = template('predict_price', templateData);
                        break;
                    case 34: // 智能选股
                        var t3 = option.data.data && option.data.data.conditions ? option.data.data.conditions.factorTitle : '';
                        templateData = Object.assign(templateData, option.data.data, {
                            title: ['股票名称', '股票价格', t3],
                            specialKeyName: 'factorValue'
                        });
                        templateHTML = template('condition_list', templateData);
                        break;
                    case 35: // 相似 K 线
                        templateData = Object.assign(templateData, option.data.data);
                        templateHTML = template('predict_kline', templateData);
                        break;
                    case 36: // 大盘风向标
                    case 80: // 新大盘风向标
                        templateData = Object.assign(templateData, option.data.data);
                        templateHTML = template('market_vane', templateData);
                        break;
                    case 37: // 投资日历
                        templateData = Object.assign(templateData, option.data.data);
                        templateHTML = template('investment_calendar', templateData);
                        break;
                    case 39: // f10 场景: 指标结果
                    case 40: //          简介信息
                        templateData = Object.assign(templateData, option.data.data);
                        templateHTML = template('f10_common', templateData);
                        break;
                    case 42: //          分红
                        templateData = Object.assign(templateData, option.data.data, {
                            title: ['年度', '方案', '分红率']
                        });
                        templateHTML = template('dividend', templateData);
                        break;
                    case 43: //          公司高管
                        templateData = Object.assign(templateData, option.data.data, {
                            title: ['姓名', '职务', '持股数(万股)', '薪酬(万元)']
                        });
                        templateHTML = template('company_manager', templateData);
                        break;
                    case 44: //          投资评级
                        templateData = Object.assign(templateData, option.data.data);
                        templateHTML = template('investment_rate', templateData);
                        break;
                    case 45: //          盈利预测
                        templateData = Object.assign(templateData, option.data.data);
                        templateHTML = template('predict_profit', templateData);
                        break;
                    case 47: //          公司学历
                        templateData = Object.assign(templateData, option.data.data, {
                            title: ['股票名称', '姓名', '职务']
                        });
                        templateHTML = template('company_manager', templateData);
                        break;
                    case 48: //          十大股东
                        templateData = Object.assign(templateData, option.data.data, {
                            title: ['股东名称', '持股比例', '持股变动']
                        });
                        templateHTML = template('stockholder', templateData);
                        break;
                    case 49: //          个股市场表现
                        templateData = Object.assign(templateData, option.data.data);
                        templateHTML = template('stock_trend', templateData);
                        break;
                    case 53: // 新智能选股
                        var t3 = '';
                        if (option.data.data) {
                            if (option.data.data.conditions) {
                                t3 = option.data.data.conditions.factorTitle;
                            }
                            if (option.data.data.specialKeyName) {
                                t3 = option.data.data.specialKeyName;
                            }
                        }
                        templateData = Object.assign(templateData, option.data.data, {
                            title: ['股票名称', '股票价格', t3],
                            specialKeyName: 'factorValue'
                        });
                        templateHTML = template('condition_list', templateData);
                        break;
                    case 54: // 语音下单
                        templateData = Object.assign(templateData, option.data.data);
                        templateHTML = template('stock_exchange', templateData);
                        break;
                    case 56: // 多条件选股
                        var titles = ['股票名称', '股票价格'].concat(option.data.data.factorKeyNames);
                        templateData = Object.assign(templateData, option.data.data, {
                            title: titles
                        });
                        templateHTML = template('multi_condition_list', templateData);
                        break;
                    case 57: // 热门股票
                        templateData = Object.assign(templateData, option.data.data);
                        templateHTML = template('hot_stock', templateData);
                        break;
                    case 58: // 个股动态
                    case 59: // 自选股动态
                        templateData = Object.assign(templateData, option.data.data);
                        templateHTML = template('stock_dynamic', templateData);
                        break;
                    case 60: // 转账
                        templateData = Object.assign(templateData, option.data.data);
                        templateHTML = template('transfer', templateData);
                        break;
                    case 61: // 大宗交易
                        templateData = Object.assign(templateData, option.data.data, {
                            title: ['交易日期', '成交价格', '成交金额', '溢价率']
                        });
                        templateHTML = template('stock_block_trading', templateData);
                        break;
                    case 62: // 公司简介
                        templateData = Object.assign(templateData, option.data.data);
                        templateHTML = template('company_profile', templateData);
                        break;
                    case 63: // 融资融券
                        templateData = Object.assign(templateData, option.data.data);
                        templateHTML = template('stock_margin_trading', templateData);
                        break;
                    case 64: // 龙虎榜
                        templateData = Object.assign(templateData, option.data.data, {
                            title: ['买入额', '买入占比', '卖出额', '卖出占比']
                        });
                        templateHTML = template('stock_longhu', templateData);
                        break;
                    case 65: // 板块资金
                        templateData = Object.assign(templateData, option.data.data, {
                            title: ['板块名称', '涨跌幅', '主力净流入'],
                            specialKeyName: 'fund'
                        });
                        templateHTML = template('block_common', templateData);
                        break;
                    case 66: // 筹码分布
                        templateData = Object.assign(templateData, option.data.data);
                        templateHTML = template('stock_cyq', templateData);
                        break;
                    case 67: // 龙虎榜单
                        templateData = Object.assign(templateData, option.data.data, {
                            title: ['股票名称', '涨跌幅', '净买入(元)', '净买入占成交比'],
                            specialKeyName: ['changeAmountRate', 'netSum', 'netRatio'],
                            // skNameHelperToggle: ['off', 'off', 'off'],
                        });
                        templateHTML = template('stock_list_common', templateData);
                        break;
                    case 68: // 机构持仓
                        templateData = Object.assign(templateData, option.data.data);
                        templateHTML = template('stock_org_position', templateData);
                        break;
                    case 69: // 限售解禁
                        templateData = Object.assign(templateData, option.data.data, {
                            title: ['解禁日期', '解禁数量', '占总股本比'],
                        });
                        templateHTML = template('stock_restricted_shares_lifted', templateData);
                        break;
                    case 71: // 大宗交易榜单
                        templateData = Object.assign(templateData, option.data.data, {
                            title: ['股票名称', '收盘价', '成交价', '溢价率', '成交额'],
                        });
                        templateHTML = template('stock_block_trading_list', templateData);
                        break;
                    case 72: // 融资融券榜单
                        templateData = Object.assign(templateData, option.data.data, {
                            title: ['股票名称', '收盘价', '涨跌幅', option.data.data.specialKeyName],
                            specialKeyName: ['closePrice', 'changeAmountRate', option.data.data.specialKey],
                            skNameHelperToggle: ['on', 'on', 'off'],
                            skNameHelperName: ['changeAmountRate']
                        });
                        templateHTML = template('stock_list_common', templateData);
                        break;
                    case 73: // 个股股东数
                        templateData = Object.assign(templateData, option.data.data);
                        templateHTML = template('stockholder_count', templateData);
                        break;
                    case 74: // 个股营业收入
                        templateData = Object.assign(templateData, option.data.data);
                        templateHTML = template('stock_operating_income', templateData);
                        break;
                    case 75: // 港资榜单
                        templateData = Object.assign(templateData, option.data.data, {
                            title: ['股票名称', '收盘价', '涨跌幅', '成交额', '净买额', '买入额', '卖出额'],
                            specialKeyName: ['closePrice', 'changeRate', 'tradingAmount', 'buyNet', 'buyAmount', 'sellAmount'],
                            skNameHelperToggle: ['on', 'on', 'off', 'on', 'off', 'off'],
                            skNameHelperName: ['changeRate']
                        });
                        templateHTML = template('stock_list_common', templateData);
                        break;
                    case 76: // 质押股票榜单
                        templateData = Object.assign(templateData, option.data.data, {
                            title: ['股票名称', '累计质押比例', '累计质押股数(股)'],
                            specialKeyName: ['pledgeRatio', 'pledgeCount'],
                            skNameHelperToggle: ['off', 'off'],
                        });
                        templateHTML = template('stock_list_common', templateData);
                        break;
                    case 77: // 大额解禁股票榜单
                        templateData = Object.assign(templateData, option.data.data, {
                            title: ['股票名称', '解禁日期', '解禁数量', '占总股本比', '解禁股份类型'],
                            specialKeyName: ['date', 'count', 'rate', 'type'],
                            skNameHelperToggle: ['off', 'off', 'off', 'off'],
                        });
                        templateHTML = template('stock_list_common', templateData);
                        break;
                    case 78: // 五星股票池
                        templateData = Object.assign(templateData, option.data.data, {
                            title: ['股票名称', '持续信号', '入选价格', '入选后最高涨幅'],
                            specialKeyName: ['signalContinue', 'signalPrice', 'riseMax'],
                            skNameHelperToggle: ['off', 'off', 'on'],
                        });
                        templateHTML = template('stock_list_common', templateData);
                        break;
                    case 79: // 热门资讯
                        templateData = Object.assign(templateData, option.data.data);
                        templateHTML = template('flash_news', templateData);
                        break;
                    case 81: // 个性诊股
                        templateData = Object.assign(templateData, option.data.data);
                        templateHTML = template('customer_diagnose', templateData);
                        break;
                    case 83: // 最新机会
                        templateData = Object.assign(templateData, option.data.data);
                        templateHTML = template('new_opportunity', templateData);
                        break;
                    case 201: // 五矿金股
                        templateData = Object.assign(templateData, option.data.data, {
                            title: ['股票名称', '股票价格', '涨跌幅', '所属题材'],
                            specialKeyName: ['changeAmountRate', 'blocks'],
                            skNameHelperToggle: ['on', 'off'],
                        });
                        templateHTML = template('stock_list_common', templateData);
                        break;
                    case 'ask':
                        templateData.msg = option.data;
                        templateHTML = template('ask', templateData);
                        break;
                    case 'error':
                        templateData = Object.assign(templateData, option);
                        templateHTML = template('error', templateData);
                        break;
                    case 'guide':
                        templateData = Object.assign(templateData, option);
                        if (SR.data.guideQuestions.qs) {
                            var randomInt = parseInt(Math.random() * (SR.data.guideQuestions.qs[0].questions.length - 1));
                            templateData.randomQuestion = SR.data.guideQuestions.qs[0].questions[randomInt];
                        }
                        templateHTML = template('no_result_guide', templateData);
                        break;
                    case 'noData': 
                        templateData = Object.assign(templateData, option);
                        templateHTML = template('no_data', templateData);
                        break;
                }
            } else if (option.type === 'suggestion') {
                // 模糊匹配建议场景
                if (option.scene === 1) {
                    templateData = Object.assign(templateData, option.data.data);
                    templateHTML = template('fuzzy_suggestion', templateData);
                } else {
                    templateData = Object.assign(templateData, option);
                    templateHTML = template('error', templateData);
                }
            } else if (option.type === 'lbs') {
                // 地理位置场景
                if (option.scene === 1) {
                    templateData = Object.assign(templateData, option.data.data);
                    templateHTML = template('lbs', templateData);
                } else {
                    templateData = Object.assign(templateData, option);
                    templateHTML = template('error', templateData);
                }
            } else if (option.type === 'external') {
                // 接入第三方数据场景
                templateData = Object.assign(templateData, option.data.data);
                templateHTML = template('external', templateData);
            } else if (option.type === 'qa' || option.type === 'kefu') {
                // 问答和客服场景
                switch (option.scene) {
                    case 1:
                    case 2:
                    case 3:
                        option.data.data.sceneType = option.type;
                        if (option.data.data.answer.length) {
                            option.data.data.answer = option.data.data.answer.replace(/[\n\r]/g, '<br/>');
                        }
                        templateData = Object.assign(templateData, option.data.data);
                        templateHTML = template('qa', templateData);
                        break;
                    default:
                        templateData = Object.assign(templateData, option);
                        templateHTML = template('error', templateData);
                        break;
                }
            } else if (option.type === 'operation' && option.data) {
                // 运营场景
                templateData = Object.assign(templateData, option.data.data);
                templateHTML = template('operation', templateData);
            } else if (option.type === 'thirdparty') {
                switch (option.scene) {
                    case 1:     // 盯盘
                        templateData = Object.assign(templateData, option.data.data);
                        templateHTML = template('my_watching', templateData);
                        break;
                    case 2:     // 消息
                        templateData = Object.assign(templateData, option.data.data);
                        templateHTML = template('my_message', templateData);
                        break;
                    // case 3:     // 成交查询
                    //     templateData = Object.assign(templateData, option.data.data);
                    //     templateHTML = template('my_transaction', templateData);
                    //     break;
                    // case 4:     // 资产查询
                    //     templateData = Object.assign(templateData, option.data.data);
                    //     templateHTML = template('my_fund', templateData);
                    //     break;
                    // case 5:     // 持仓查询
                    //     templateData = Object.assign(templateData, option.data.data);
                    //     templateHTML = template('my_position', templateData);
                    //     break;
                    case 3:     // 成交查询
                    case 4:     // 资产查询
                    case 5:     // 持仓查询
                        templateData = Object.assign(templateData, option.data.data);
                        templateHTML = template('operation', templateData);
                        break;
                    case 6:     // 网点查询
                    case 7:
                        templateData = Object.assign(templateData, option.data.data);
                        templateHTML = template('service_list', templateData);
                        break;
                    default:
                        templateData = Object.assign(templateData, option);
                        templateHTML = template('error', templateData);
                        break;
                }
            } else if (option.type === 'complex') {
                $(option.data.data).each(function() {
                    switch(this.scene) {
                        case 41:
                            this.data.title = ['板块名称', '涨跌幅', '领涨个股'];
                            break;
                    }
                });
                templateData = Object.assign(templateData, option.data);
                templateHTML = template('complex', templateData);
            } else {
                templateData = Object.assign(templateData, option);
                templateHTML = template('error', templateData);
            }
        } catch(err) {
            SR.state.isDebug && console.log(err);
            SR.App.trigger('renderAnswerFail', [option]);
            SR.state.isDebug && console.info('fire:renderAnswerFail');
            templateHTML = template('error', {
                scene: 'error',
                msg: '哎呀，'+ SR.permissions.title +'没有听清，请再说一遍'
            });
        }
        if (templateHTML === '{Template Error}') {
            SR.App.trigger('renderAnswerFail', [option]);
            SR.state.isDebug && console.info('fire:renderAnswerFail');
            templateHTML = null;
        }
        return templateHTML;
    }
})();
